import React from 'react'

export const StateOfHTMLIcon = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1000"
        height="1000"
        fill="none"
        viewBox="0 0 1000 1000"
    >
        <path d="M934.997 570.883 601.584 763.382l48.777-169.86h131.321l19.652-68.534H764.03l45.737-26.407zM351.251 407.431h-83.013l-18.297 63.806-58.918 34.016-125.23-72.303 333.415-192.497zM943.658 431.279l-8.661-4.999 8.661-5zM517.125 417.417 503.2 465.981h-34.104l-33.709 117.557h-48.564l33.709-117.557h-34.105l13.926-48.564zM572.611 417.417l-3.969 13.843 24.51-13.843h48.564l-3.97 13.842 24.511-13.842h8.921l34.011 19.636-42.002 146.485h-48.565l31.756-110.747-24.51 13.842-27.786 96.905h-48.564l31.755-110.747-24.509 13.842-27.787 96.905h-48.564l47.635-166.121z"></path>
        <path d="m758.732 467.965-19.213 67.008h48.564l-13.925 48.565h-97.129l40.037-139.627zM306.464 479.712l24.51-13.843 13.893-48.452h48.564l-47.634 166.121h-21.371l-23.331-13.471 14.001-48.825-24.51 13.843-7.114 24.808-41.666-24.057 33.956-118.419h48.564zM943.658 421.28 591.921 218.205l-35.617 124.04 387.354 223.639zM57.134 582.556 409.13 785.782l35.62-124.041L57.134 437.952z"></path>
    </svg>
)

export default StateOfHTMLIcon
